import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;
global.jQuery = jQuery;
global.$ = jQuery;

import popup from 'jquery-popup-overlay';
import 'jquery-ui/ui/widgets/tabs';
import 'jquery-ui/ui/widgets/accordion';
import 'jquery.scrollbar';
import 'lazysizes';

import './lottie-logo.js';
import './_script.js';
import './script_only_for_html';
import './map.js';
import './timecity.js';
import './sliders.js';
import './rate.js';
import './init_imask.js';
import './gallery_360.js';
import './modernizr-custom.js';
import './store_list.js';
import './CompareAndFavorite.js';
import './cart.js';
import './order.js';

// bxSlider
import './alt/jquery.bxslider_costom.js';
import './product_sliders.js';

// Взято с сайта, в вёрстке возможно не нужны, но нужны на сайте
import './custom.js';

import '../javascript/ajax/script.js';
//import '../javascript/cart/script.js';
import '../javascript/forms/FormsDefault.js';
import '../javascript/forms/FormsOrder.js';
import '../javascript/lang_switcher/script.js';
import '../javascript/privacy_policy/script.js';
import '../javascript/show_more/script.js';